// extracted by css-extract-rspack-plugin
export default {"ActionMenu_Overlay":"AddFileDropdownButton-module__ActionMenu_Overlay__l0CIW"};